import { get } from 'lodash'
import { required, email } from 'utils/validation'
import { PAYMENT_TYPES } from 'constants/enums'

const validate = values => {
  let errors = {}

  errors.helpers = {
    price: required(get(values, 'helpers.price'))
  }

  if (
    get(values, 'helpers.price') === PAYMENT_TYPES.online.id &&
    get(values, 'helpers.isUnderAge')
  ) {
    errors.parentEmail =
      required(get(values, 'parentEmail')) || email(get(values, 'parentEmail'))

    if (
      get(values, 'parentEmail') &&
      get(values, 'confirmEmail') &&
      get(values, 'parentEmail') !== get(values, 'confirmEmail')
    ) {
      errors = {
        ...errors,
        confirmEmail: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  if (get(values, 'helpers.price') === 'online') {
    errors.enteredTransactionId = required(get(values, 'enteredTransactionId'))
  }

  return errors
}

export default validate
